import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=760f549d&scoped=true&"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js&"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTemplate.vue?vue&type=style&index=0&id=760f549d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760f549d",
  null
  
)

export default component.exports